import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

import { PaymentMethodsEnum } from '@ctct/domain-layer';

export interface ISingleBillPaymentMethodsSlice {
  selectedMethod: PaymentMethodsEnum;
  currentPaymentMethod: PaymentMethodsEnum | null;
  paymentMethodCanBeUpdated: boolean;
  selectedBillingCountry: string | null;
  selectedBillingCurrency: string | null;
  paymentElementCountryBucket: string | null;
  paymentElementConfigurationBucket: string | null;
  hasInteractedWithPaymentElement: boolean;
  tabsLoading: boolean;
  paymentMethodsFullLoading: boolean;
  showSecurePayIframeBlockedMessage: boolean;
  showCvvTooltip: boolean;
  addedCssToIframe: boolean;
  creditCardToken: string | null;
  creditCardConnected: boolean;
  echeckConnected: boolean;
  securePayEdited: boolean;
  echeckToken: string | null;
}

export const createSingleBillPaymentMethodsSliceDefaultValues = (): ISingleBillPaymentMethodsSlice => ({
  selectedMethod: PaymentMethodsEnum.CREDIT_CARD,
  currentPaymentMethod: null,
  paymentMethodCanBeUpdated: false,
  selectedBillingCountry: null,
  selectedBillingCurrency: null,
  paymentElementCountryBucket: null,
  paymentElementConfigurationBucket: null,
  hasInteractedWithPaymentElement: false,
  tabsLoading: false,
  paymentMethodsFullLoading: false,
  showSecurePayIframeBlockedMessage: false,
  showCvvTooltip: false,
  addedCssToIframe: false,
  creditCardToken: null,
  creditCardConnected: false,
  echeckConnected: false,
  securePayEdited: false,
  echeckToken: null,
});

export const createSingleBillPaymentMethodsSlice: StateCreator<ISingleBillPaymentMethodsSlice> = () =>
  createSingleBillPaymentMethodsSliceDefaultValues();

export type SingleBillPaymentMethodsPageStore = UseBoundStore<StoreApi<ISingleBillPaymentMethodsSlice>>;

// create the hooks helpers
export const createSingleBillPaymentMethodsHooks = (pageStore: SingleBillPaymentMethodsPageStore) => {
  return {
    useSelectedMethod: () => pageStore((state) => state.selectedMethod),
    useSecurePayIframeState: () =>
      pageStore((state) => ({
        showCvvTooltip: state.showCvvTooltip,
        addedCssToIframe: state.addedCssToIframe,
        creditCardConnected: state.creditCardConnected,
        echeckConnected: state.echeckConnected,
        securePayEdited: state.securePayEdited,
        showSecurePayIframeBlockedMessage: state.showSecurePayIframeBlockedMessage,
      })),
    useTabsLoading: () => pageStore((state) => state.tabsLoading),
    useFullLoading: () => pageStore((state) => state.paymentMethodsFullLoading),
    useSelectedBillingCountry: () => pageStore((state) => state.selectedBillingCountry),
    useSelectedBillingCurrency: () => pageStore((state) => state.selectedBillingCurrency),
  };
};

export type SingleBillPaymentMethodsHooks = ReturnType<typeof createSingleBillPaymentMethodsHooks>;
